import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  getLifter,
  getCompleteLiftingOrder,
  getScreenMedia,
  getCurrentPlatform
} from 'selectors';
import Table from 'components/table/Table';
import DefaultCell from './cells/DefaultCell';

class LifterOrderTable extends Component {

  getAllColumns = () => {
    return [
      {key: 'attemptsOut', label: 'Out', width: 50, renderer: DefaultCell},
      {key: 'lifter.name', label: 'Name', width: 200, renderer: DefaultCell},
      {key: 'attempt.liftName', label: 'Lift', width: 70, renderer: DefaultCell},
      {key: 'attemptNumber', label: 'Attempt', width: 70, renderer: DefaultCell},
      {key: 'attempt.weight', label: 'Weight', width: 70, renderer: DefaultCell},
      {key: 'session', label: 'Session', width: 70, renderer: DefaultCell},
      {key: 'flight', label: 'Flight', width: 70, renderer: DefaultCell}
    ];
  }

  getCellLines = (index) => {
    return 1;
  }

  createDataArray = () => {
    const { completeLiftingOrder } = this.props;
    // TODO: move this to a selectors

    const order = _.cloneDeep(completeLiftingOrder);

    let isPastCurrentAttempt = false;
    let attemptsOut = 0;
    _.each(order, (attempt) => {
      if(isPastCurrentAttempt) {
        attemptsOut++;
        attempt.attemptsOut = attemptsOut;
      }

      if(attempt.weight && !attempt.attempt.result) {
        isPastCurrentAttempt = true;
      }
    });

    order.unshift({row: 'header'});

    return order;
  }

  render() {
    const { lifter, media, currentPlatform } = this.props;

    const sortedAttempts = this.createDataArray();
    const currentAttemptIndex = _.findIndex(sortedAttempts, (row) => _.get(row, 'attemptId') === _.get(currentPlatform, 'currentAttemptId'));

    const scrollToRow = _.findIndex(sortedAttempts, (attempt) => _.get(attempt, ['lifter', '_id']) === lifter._id, currentAttemptIndex);
    return (
      <div className="lifter-order-table">
        <Table
          numberOfFixedLeftColumns={2}
          data={sortedAttempts}
          columns={this.getAllColumns()}
          getCellLines={this.getCellLines}
          meet={this.props.meet}
          scrollToRow={scrollToRow}
          scrollToAlignment='center'
          hightlightRow={scrollToRow}
          media={media}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const lifter = getLifter(state, props);
  props = {...props, platformId: lifter.platformId};

  return {
    completeLiftingOrder: getCompleteLiftingOrder(state, props),
    currentPlatform: getCurrentPlatform(state, props),
    lifter,
    media: getScreenMedia(state, props)
  };
};

const actions = {};

export default withRouter(connect(mapStateToProps, actions)(LifterOrderTable));
